export enum EInternalTerm {
  PAYMENT_NOT_FOUND = 'PAYMENT_NOT_FOUND',
  PAYMENT_ALREADY_PROCESSED = 'PAYMENT_ALREADY_PROCESSED',
  PAYMENT_EXPIRED = 'PAYMENT_EXPIRED',
  PAYMENT_COMPLETED = 'PAYMENT_COMPLETED',
  INVALID_REQUEST = 'INVALID_REQUEST',
  CHECKOUT_PAYMENT_NOT_FOUND = 'CHECKOUT_PAYMENT_NOT_FOUND',
  INTERNAL_ERROR = 'INTERNAL_ERROR',
}

export type TMessageResponse = {
  status?: 'error' | 'success' | 'warning';
  title?: string;
  description: string;
};
